import { useMutation } from "react-query";
import { cloneReadingOrder } from "../../services/readingOrdersApi";
import { useToast } from "@chakra-ui/react";
import { usePremium } from "../../contexts/Premium";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../analytics";

/**
 * Hook to clone a reading order
 */
export default function useCloneReadingOrder(readingOrderId) {
  const mutation = useMutation(() => cloneReadingOrder(readingOrderId));
  const { isPremium } = usePremium();
  const navigate = useNavigate();
  const toast = useToast();

  const onClickClone = () => {
    if (!isPremium) {
      trackEvent("upgrade_clicked", {
        source: "clone_reading_order",
        reading_order_id: readingOrderId,
      });
      navigate("/go-premium");
      return;
    }

    mutation
      .mutateAsync()
      .then((data) => {
        trackEvent("reading_order_cloned", {
          reading_order_id: readingOrderId,
          new_reading_order_id: data?.readingOrderId,
        });
        toast({
          title: "Reading order cloned.",
          description:
            "A clone of the reading order has been added to your reading orders.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        navigate(`/my-orders/${data.readingOrderId}`);
      })
      .catch(() => {
        toast({
          title: "An error occurred.",
          description:
            "Please try again or contact support if the issue persists.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };

  return {
    onClickClone,
    isCloning: mutation.isLoading,
  };
}
